<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>查排名</el-breadcrumb-item>
        <el-breadcrumb-item>数据查询</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">数据查询</h2>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="院校名称"
                      prop="name">
          <el-input v-model="query.keyword"
                    placeholder="输入院校名称"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="分类"
                      prop="college_categorys">
          <el-select v-model="query.college_categorys"
                     placeholder="请选择"
                     @change="fetchList(true)"
                     clearable
                     multiple
                     style="width:300px;">
            <el-option v-for="(item,index) in $store.state.collegeCategoryList"
                       :key="index"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区"
                      prop="province_code">
          <el-select v-model="query.province_code"
                     placeholder="请选择"
                     @change="fetchList(true)"
                     clearable
                     filterable>
            <el-option v-for="(item,index) in $store.state.provinceList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份"
                      prop="year">
          <el-select v-model="adjust_year"
                     placeholder="请选择"
                     @input="fetchList(true)">
            <el-option v-for="item in filter.years"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">查找结果</h3>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="radio1"
                            @change="radioChange">
              <el-radio-button label="college">院校</el-radio-button>
              <el-radio-button label="major">专业</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           align="center">
          </el-table-column>
          <el-table-column prop="college_name"
                           label="院校名称"
                           align="center"
                           width="200">
          </el-table-column>
          <el-table-column prop="province_name"
                           label="地区"
                           align="center">
          </el-table-column>
          <el-table-column label="分类"
                           align="center"
                           width="300"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{formateCategorys(scope.row.categorys)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="查询人数"
                           align="center">
            <template slot-scope="scope">
              <span>{{scope.row.user_count}}人</span>
            </template>
          </el-table-column>
          <el-table-column label="更新日期"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.update_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           v-if="isfixed"
                           fixed="right">
            <template slot-scope="scope">
              <el-button type="text"
                         @click="handelGoAcademy(scope.row)">学院详情</el-button>
              <el-button type="text"
                         @click="handelGoMajor(scope.row)">专业详情</el-button>
              <el-button type="text"
                         @click="handelGoUserList(scope.row)">学员列表</el-button>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="c"
                                    style="margin-bottom:6px;"><span @click="handelGoAcademy(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      学院详情
                    </span></el-dropdown-item>
                  <el-dropdown-item command="c"
                                    style="margin-bottom:6px;"><span @click="handelGoMajor(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      专业详情
                    </span></el-dropdown-item>
                  <el-dropdown-item command="c"
                                    style="margin-bottom:6px;"><span @click="handelGoUserList(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      学员列表
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { rankcollegelist, adjustConfigList } from '@/api/rank'

export default {
  components: {},
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        // year: 2025,
        college_categorys: '',
        keyword: '',
        province_code: '',
      },
      pageTotal: 10,
      results: [],
      radio1: 'college',
      isfixed: document.body.clientWidth < 820 ? false : true,
      filter: {
        years: [
          {
            label: '2027年',
            value: 2027,
          },
          {
            label: '2026年',
            value: 2026,
          },
          {
            label: '2025年',
            value: 2025,
          },
          {
            label: '2024年',
            value: 2024,
          },
          {
            label: '2023年',
            value: 2023,
          },
        ],
      },
      adjust_year: '',
    }
  },
  created() {
    this.$store.dispatch('getCollegeCategorys')
    this.$store.dispatch('getProvinceList')
    this.getYear()
  },
  methods: {
    getYear() {
      adjustConfigList().then((res) => {
        this.adjust_year = res.adjust_year
        this.fetchList()
      })
    },
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      if (params.college_categorys) {
        params.college_categorys = params.college_categorys
          .filter((v) => v)
          .join(',')
      }
      params.year = this.adjust_year
      rankcollegelist(params).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchList()
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.college_categorys) {
        this.query.college_categorys = this.query.college_categorys.split(',')
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      if (params.college_categorys) {
        params.college_categorys = params.college_categorys
          .filter((v) => v)
          .join(',')
      }
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        })
    },
    formateCategorys(arr) {
      if (arr) {
        return arr
          .map((v) => {
            return v.name
          })
          .join(',')
      } else {
        return '无'
      }
    },
    radioChange(e) {
      if (e == 'major') {
        this.$router.replace('/rank/category')
      }
    },
    handelGoAcademy(row) {
      this.$router.push(`/rank/academy/${row.college_code}`)
    },
    handelGoMajor(row) {
      this.$router.push(`/rank/major/${row.college_code}`)
    },
    handelGoUserList(row) {
      this.$router.push(`/rank/userlist?collegeCode=${row.college_code}`)
    },
  },
}
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 35px;
    .table-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0;
      width: 101.5%;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
